module.exports = __webpack_public_path__ + "static/media/Leccion-8-13-Cuida-tu-Huerto.7367779c.pdf";